import React from "react";
import { useNavigate } from "react-router-dom";
import SettingTemplate from "src/components/templates/SettingTemplate/SettingTemplate";


export default function Settings() {
  const navigate = useNavigate();
  return <SettingTemplate navigate={navigate} />;
}
